import React from 'react';

import { TabsProps } from 'views/Offers/RollingOffers/Form/RollingOfferForm.types';

import { SubOffersList } from '../SubOfferCard';

const ConfigurationTab: React.FC<TabsProps> = ({
  formikProps,
  rollingOfferId,
  productsSequence,
  setProductsSequence,
  setBarPointsValidity
}) => {
  return (
    <SubOffersList
      formikProps={formikProps}
      rollingOfferId={rollingOfferId}
      productsSequence={productsSequence}
      setProductsSequence={setProductsSequence}
      setBarPointsValidity={setBarPointsValidity}
    />
  );
};

export default ConfigurationTab;
